export { C } from "../ipd-billing/constants";

/** Base path for all OT routes — update here only. */
export const OT_BASE = "/ot_dashboard";

/**
 * Sidebar navigation — add a screen by appending one entry here
 * and registering its Route in App.js.
 */
export const NAV = [
  { id: "dashboard", label: "Dashboard", icon: "dashboard", route: OT_BASE },
  { id: "workflows", label: "Workflows", icon: "journey", route: `${OT_BASE}/workflows` },
  { id: "schedule", label: "OT Schedule", icon: "clock", route: `${OT_BASE}/schedule` },
  { id: "cases", label: "Live Cases", icon: "trending", route: `${OT_BASE}/cases` },
  { id: "checklists", label: "Checklists", icon: "check", route: `${OT_BASE}/checklists` },
];

export const WORKFLOW_CATEGORIES = [
  "Scheduling",
  "Assessment",
  "Peri-Operative",
  "Support",
];
